import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import { Hero, Section } from "@/components/layout/Sections";
import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink } from "lucide-react";

const AUTOSCOUT_URL = "https://www.autoscout24.it/concessionari/nsa-srl?srsltid=AfmBOoqgq3wUboYFCzsjLFglG1QP93myyDXVk5tOTMzViCJMImhulu6X";

export default function AutoHome() {
  return (
    <PageLayout>
      <Hero
        image="/showroom/auto.png"
        eyebrow="Vendita · Noleggio · Assistenza"
        title="L'auto che stai sognando la trovi da noi"
        subtitle=""
        align="top"
      />

      <Section>
        <div className="grid md:grid-cols-5 gap-10 md:gap-16">
          <div className="md:col-span-3">
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">Autosalone</span>
            <h2 className="font-display uppercase tracking-tight text-4xl md:text-5xl mt-3 leading-[0.95]">
              L'auto che cerchi,<br />la trovi da noi
            </h2>
          </div>
          <div className="md:col-span-2 space-y-5 text-gray-700 leading-relaxed">
            <p>Nei <strong>300 mq di esposizione</strong> del nostro autosalone di Casnigo, tra Bergamo e Clusone, vendiamo auto multimarca <strong>nuove ed usate</strong>, auto aziendali e auto a Km Zero, spesso in pronta consegna, oltre a veicoli commerciali e da lavoro, ideali per ogni tipo di necessità.</p>
            <p>Le collaborazioni dirette con le case madri automobilistiche e con rivenditori ufficiali in tutta Italia ci consentono di procurare l'auto che cerchi in tempi brevi ma soprattutto che soddisfa pienamente le tue esigenze.</p>
          </div>
        </div>
      </Section>

      {/* OFFICINA — spostata prima della permuta */}
      <Section tone="dark">
        <div className="grid md:grid-cols-5 gap-10 items-center">
          <div className="md:col-span-3">
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">Officina</span>
            <h2 className="font-display uppercase text-4xl md:text-5xl mt-3">
              Tranquillo, alla tua auto pensiamo noi
            </h2>
            <p className="mt-4 text-white/80 leading-relaxed max-w-2xl">
              Il team in officina è il vero fiore all'occhiello della nostra realtà. Manutenzione ordinaria e straordinaria,
              cambio gomme, riparazioni e customizzazioni: qui trovi tutta l'assistenza specializzata di cui hai bisogno.
            </p>
          </div>
          <div className="md:col-span-2 flex md:justify-end">
            <Link to="/auto/officina" className="bg-white text-gray-900 label-eyebrow px-6 py-4 inline-flex items-center gap-3 hover:bg-white/90">
              SCOPRI L'OFFICINA <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </Section>

      {/* PERMUTA + SERVIZI EXTRA */}
      <Section tone="gray">
        <div className="grid md:grid-cols-2 gap-10">
          <div className="card-flat p-8 bg-white">
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">Permuta</span>
            <h3 className="font-display uppercase text-3xl mt-3">La giusta valutazione per la tua permuta</h3>
            <p className="mt-4 text-gray-700 leading-relaxed">
              Valutiamo sempre il ritiro della tua auto e se la nostra proposta non è di tuo gradimento, ti offriamo il servizio di
              <strong> conto vendita</strong> per aiutarti a trovare un acquirente interessato e gestire al meglio la trattativa privata,
              così da valorizzare al massimo il tuo usato.
            </p>
          </div>
          <div className="card-flat p-8 bg-gray-900 text-white border-gray-900" style={{ background: "#111827" }}>
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">Servizi extra</span>
            <h3 className="font-display uppercase text-3xl mt-3">Su misura per te</h3>
            <p className="mt-4 text-white/80 leading-relaxed">
              Siamo partner <strong>SANTANDER</strong> e <strong>FIDITALIA</strong>: finanziamenti, leasing e assicurazioni su misura,
              oltre a un servizio di assistenza post-vendita nella nostra officina specializzata.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="text-xs bg-white/10 border border-white/20 px-3 py-1">Santander</span>
              <span className="text-xs bg-white/10 border border-white/20 px-3 py-1">Fiditalia</span>
            </div>
          </div>
        </div>
      </Section>

      {/* AUTOSCOUT24 — card cinematografica con logo */}
      <Section>
        <div className="mb-6">
          <span className="label-eyebrow text-[color:var(--nsa-orange)]">Vedi tutte le auto</span>
          <h2 className="font-display uppercase text-4xl md:text-5xl mt-3 leading-[0.95]">
            Il nostro parco auto<br />sempre online
          </h2>
        </div>
        <a
          href={AUTOSCOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative aspect-[21/9] overflow-hidden block bg-gray-900 text-white"
          data-testid="autoscout-link"
        >
          <div
            className="absolute inset-0 bg-cover bg-center scale-105 group-hover:scale-100 transition-transform duration-[900ms]"
            style={{ backgroundImage: "url(/showroom/auto.png)" }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/25" />
          <div className="absolute -right-16 -top-16 h-72 w-72 rounded-full bg-[#FFDF00] blur-3xl opacity-15 group-hover:opacity-30 transition-opacity duration-700" />
          <div className="relative h-full p-6 md:p-10 flex flex-col justify-between">
            <div className="flex items-start justify-between gap-4">
              <div className="bg-white px-3.5 py-2 md:px-4 md:py-2.5 shadow-lg transform group-hover:-translate-y-0.5 transition-transform">
                <img src="/logos/autoscout24.png" alt="AutoScout24" className="h-5 md:h-6 w-auto" />
              </div>
              <ExternalLink size={20} className="text-white/50 group-hover:text-[#FFDF00] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition duration-300" />
            </div>
            <div>
              <h3 className="font-display uppercase text-2xl md:text-4xl leading-[0.95] max-w-2xl">
                Tutte le auto disponibili in vendita e in pronta consegna
              </h3>
              <p className="mt-3 text-white/75 text-sm md:text-base max-w-xl">
                Sfoglia i nostri annunci ufficiali su AutoScout24: nuovo, usato, aziendali e a chilometro zero.
              </p>
              <span className="mt-6 inline-flex items-center gap-2 label-eyebrow border border-white/30 px-4 py-2.5 group-hover:border-[#FFDF00] group-hover:text-[#FFDF00] transition-colors">
                Apri il dealer <ArrowRight size={14} />
              </span>
            </div>
          </div>
        </a>
      </Section>
    </PageLayout>
  );
}
